import { useLingui } from '@lingui/react/macro';
import { useMemo } from 'react';
import { pagesAttributes } from './pages';

export type DocEntry = {
  slug: string;
  title: string;
  description?: string;
  section?: string;
};

/** Every docs page's frontmatter for the active language, sorted by title. */
export const useDocsIndex = (excludeSlug?: string): DocEntry[] => {
  const {
    i18n: { locale },
  } = useLingui();

  return useMemo(() => {
    const entries: DocEntry[] = [];
    for (const [slug, langs] of Object.entries(pagesAttributes)) {
      if (slug === excludeSlug) continue;
      // Fall back to en while the translation is not pulled yet.
      const attributes = langs[locale] ?? langs.en;
      if (!attributes?.title) continue;
      entries.push({ slug, ...attributes, title: attributes.title });
    }
    return entries.sort((a, b) => a.title.localeCompare(b.title));
  }, [locale, excludeSlug]);
};
